import { CoverTemplate } from '../types';
import { standardLabReportCoverTemplate } from './standardLabReportCover';
import { classicAcademicTemplate } from './classicAcademic';
import { minimalAcademicTemplate } from './minimalAcademic';
import { modernAcademicTemplate } from './modernAcademic';
import { labReportCoverTemplate } from './labReportCover';
import { assignmentCoverTemplate } from './assignmentCover';
import { projectCoverTemplate } from './projectCover';

export const COVER_TEMPLATES: CoverTemplate[] = [
  standardLabReportCoverTemplate,
  classicAcademicTemplate,
  minimalAcademicTemplate,
  modernAcademicTemplate,
  labReportCoverTemplate,
  assignmentCoverTemplate,
  projectCoverTemplate,
];

export function getCoverTemplateById(id: string): CoverTemplate {
  const found = COVER_TEMPLATES.find((t) => t.id === id);
  return found || classicAcademicTemplate;
}
